/* eslint-disable react-refresh/only-export-components */

import { createFileRoute } from '@tanstack/react-router';
import { UserCreditTable } from '../../../features/statistics/components/user-credit-table';

export const Route = createFileRoute(
  '/_creator-center/admin/statistics/usage-limit',
)({
  component: Statistics,
});

function Statistics() {
  return <UserCreditTable></UserCreditTable>;
}
